import { Scan } from '../models/scan';
console.log('WEEK_START:', getWeekStart(), 'WEEK_END:', getWeekEnd());

// Functions to dynamically get the current week's start (Monday) and end (next Monday) in UTC
export function getWeekStart(): Date {
  const now = new Date();
  const utcDay = now.getUTCDay(); // 0 (Sun) - 6 (Sat)
  const diffToMonday = (utcDay + 6) % 7; // days since Monday
  return new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - diffToMonday, 0, 0, 0, 0)
  );
}

export function getWeekEnd(): Date {
  const weekStart = getWeekStart();
  const weekEnd = new Date(weekStart);
  weekEnd.setUTCDate(weekStart.getUTCDate() + 7);
  weekEnd.setUTCHours(0, 0, 0, 0);
  return weekEnd;
}

export const TOAST_DURATION = 3000;
export const PRODUCT_KEY = 'weeklyscan';
export const MAX_WEEKLY_SCANS = 3;
export const NUM_FREE_SCANS = 1;

export const calculateScansAvailable = (scans: Scan[], isSubscribed: boolean): number => {
  const processedScans = scans.filter(scan => scan.isProcessed && scan.processedAt);
  if (processedScans.length < NUM_FREE_SCANS) {
    return NUM_FREE_SCANS - processedScans.length;
  }

  if (!isSubscribed) {
    return 0;
  }

  const scansThisWeek = scans.filter(
    scan =>
      scan.isProcessed &&
      scan.processedAt &&
      new Date(scan.processedAt) >= getWeekStart() &&
      new Date(scan.processedAt) < getWeekEnd()
  );
  return MAX_WEEKLY_SCANS - scansThisWeek.length;
};
